import React from 'react';
import {
  Container, Image, Button
} from 'semantic-ui-react';
// import { compose } from 'react-apollo';
import { inject, observer } from 'mobx-react';
import Router, { withRouter } from 'next/router';

import { ozzyInstance, classAppInstance, asset } from '../lib/Util';

import Main from '../layouts/Main';

// import Config from '../lib/Config';
import { __ } from '../lib/I18n';
import Wrapper from '../lib/Wrapper';
import Loading from '../components/Loading';
import CoronaVirusCard from '../components/CoronaVirusCard';

const querySubscriptions = `query DrixMySubscriptions($input:FilterOrganizationInput!) {
  myself{
    organizations(filter: $input){
      entries{
        subscriptions{
          totalCount
          entries{
            id
            research{
              id
              name
            }
          }
        }
      }
    }
  }
}`;

const queryEntityGroup = `query DrixEntityGroups($id: ID!) {
  node(id: $id) {
    ... on Organization {
      groups(limit: 200) {
        nodes {
          id: dbId
          name
          entities(limit: 2000) {
            nodes {
              id: dbId
            }
          }
        }
      }
    }
  }
}
`;

const CORONA_RESEARCH = 1;

@observer
class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      subscriptions: null,
      groups: null
    };
  }

  componentDidMount() {
    const { props } = this;
    const { store } = props;

    if (!store || !store.user) {
      if (!store.errorMessage) Router.push('/login');
      else Router.push(`/login?error_message=${encodeURI(store.errorMessage)}`, 'login');
      return;
    }

    if (props.router && props.router.query && props.router.query.error === 'authorization_error') {
      // User cancelled install
      Router.push('/profile');
      return;
    }

    if (store.user) {
      if (props.store.selectedOrganization) {
        let ozzyResponse;
        let classAppResponse;
        Promise.all([
          // Get Subscriptions
          ozzyInstance(props.store.user.accessToken).post('', {
            query: querySubscriptions,
            variables: { input: { id: props.store.selectedOrganization.id } }
          }).then((response) => {
            ozzyResponse = response;
          }).catch((error) => {
            this.setState({ loading: false, error: error.message });
          }),
          // Get Groups
          classAppInstance(props.store.user.accessToken).post('', {
            query: queryEntityGroup,
            variables: { id: props.store.selectedOrganization.classapp_id }
          }).then((response) => {
            classAppResponse = response;
          }).catch((error) => {
            this.setState({ loading: false, error: error.message });
          })
        ]).then(() => {
          this.setState({
            subscriptions: ozzyResponse.data.data.myself.organizations.entries[0].subscriptions.entries,
            groups: classAppResponse.data.data.node.groups.nodes,
            loading: false
          });
        });
      } else {
        this.setState({ loading: false, subscriptions: [], groups: [] });
      }
    }
  }

  render() {
    const { props } = this;
    if (!props.store.user) return null;
    const {
      loading, error, subscriptions, groups
    } = this.state;
    const { store } = props;

    if (loading) {
      return (
        <Main className="container-loading">
          <Loading width={40} height={40} />
        </Main>
      );
    }

    if (error) {
      return (
        <Main className="container-root">
          <Container fluid>
            <div style={{ justifyContent: 'center' }}>
              <span>Erro na query: </span>
              <span>{error}</span>
            </div>
          </Container>
        </Main>
      );
    }
    return (
      <Main className="container-root">
        {
          subscriptions.length ? null : (
            <div className="container-no-organization">
              <span className="title">{__('O Monitor ainda não está ativo!')}</span>
              <span className="subtitle">{__('Clique em configurar para ativar.')}</span>
              <Image src={asset('no-organization.png')} size="medium" />
              <Button onClick={() => Router.push('/profile')} primary className="button" size="small">{__('Configurar')}</Button>
            </div>
          )
        }
        {
          subscriptions.map(subscription => ((subscription.research.id == CORONA_RESEARCH)
            ? (
              <CoronaVirusCard
                subscriptionId={subscription.id}
                key={CORONA_RESEARCH}
                organization={store.selectedOrganization}
                groups={groups}
              />
            ) : null))
        }
      </Main>
    );
  }
}


export default Wrapper(Dashboard);
